import { getLanguageCodeForCountry } from './localeFormatter';

export const buildPowerBiUrl = (
  reportId: string,
  countryIsoCode: string | undefined
) => {
  const lang = getLanguageCodeForCountry(countryIsoCode);

  return (
    'https://app.powerbi.com/reportEmbed?reportId=' +
    reportId +
    '&filterPaneEnabled=false&navContentPaneEnabled=false&language=' +
    lang
  );
};
